import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';
import { Router } from '@angular/router';
import {environment} from "../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class UserInterceptor implements HttpInterceptor {

  constructor(
    private authService: AuthService,
    private router: Router
  ) { }

  /**
   * O realm sai daqui, e a leitura é NO MOMENTO EM QUE A REQUEST SAI: `getUser()`
   * relê o usuário persistido a cada request. Quem troca de realm tem de gravar
   * antes de avisar as telas (ver `AuthService.toggleGlobalAccount`), senão o
   * fetch disparado pela troca chega ao backend com o `global=` do realm
   * anterior.
   *
   * O formato da query string é contrato com o backend e não muda.
   */
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {

    if (this.authService.isLogged()) {
      const user = this.authService.getUser();
      let newUrl = req.url + (req.url.includes('?') ? '&' : '?') + 't=' + Date.now();

      if (this.authService.isSimulating) {
        newUrl += `&simulate=${user.id}`;
      }

      newUrl += `&global=${user.globalActivated}`;

      if (!environment.production) {
        newUrl += '&XDEBUG_SESSION=docker'
      }

      req = req.clone({
        url: newUrl
      });
    }

    return next.handle(req);
  }
}
